'use client';

import { useState } from 'react';
import { UseFormRegisterReturn, FieldValues, Path } from 'react-hook-form';

import { TextareaProps } from './types';

import { classNames } from '@/shared/lib/classNames/classNames';

export const Textarea = <T extends FieldValues>({
  label,
  error,
  watch,
  className,
  ...inputProps
}: TextareaProps<T> & UseFormRegisterReturn) => {
  const [isFocused, setIsFocused] = useState(false);
  const value = watch(inputProps.name as Path<T>);

  return (
    <div className={classNames({ cls: 'w-full', additional: [className] })}>
      <div className="relative h-[118px]">
        <textarea
          {...inputProps}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          id={label}
          className={classNames({
            cls: 'transition-bg peer bg-custom-surface-contrast-low h-full w-full resize-none rounded-xl border border-transparent px-3 py-2 pt-6 text-base duration-300 outline-none',
            mods: {
              'border-status-errorSecondary bg-status-errorTertiary': !!error,
              'hover:bg-surface-base-inverse-tertiary focus:bg-surface-base-inverse-tertiary':
                !error,
            },
          })}
        />
        <label
          htmlFor={label}
          className={classNames({
            cls: 'text-text-base-secondary pointer-events-none absolute left-3 -translate-y-1/2 cursor-text text-base tracking-[-0.01rem] transition-all duration-300 peer-focus:top-4',
            mods: {
              'top-4 text-sm leading-[18px]': isFocused || value,
              'top-7': !(isFocused || value),
            },
          })}
        >
          {label}
        </label>
      </div>
      <span className="text-status-error block h-5 text-sm leading-[1.125rem]">
        {error?.message}
      </span>
    </div>
  );
};
